import { throttle } from "@tldraw/editor";
const hoverLockedEditors = /* @__PURE__ */ new WeakMap();
function getShapeToHover(editor) {
  const hitShape = editor.getShapeAtPoint(editor.inputs.getCurrentPagePoint(), {
    hitInside: false,
    hitLabels: false,
    hitLocked: editor.options.selectLockedShapes,
    margin: editor.getHitTestMargin(),
    renderingOnly: true
  });
  if (!hitShape) return null;
  let shapeToHover = void 0;
  const outermostShape = editor.getOutermostSelectableShape(hitShape);
  if (outermostShape === hitShape) {
    shapeToHover = hitShape;
  } else {
    if (outermostShape.id === editor.getFocusedGroupId() || editor.getSelectedShapeIds().includes(outermostShape.id)) {
      shapeToHover = hitShape;
    } else {
      shapeToHover = outermostShape;
    }
  }
  return shapeToHover.id;
}
function _updateHoveredShapeId(editor) {
  if (editor.isDisposed) return;
  const cameraMoving = editor.getCameraState() === "moving";
  if (!cameraMoving) {
    hoverLockedEditors.set(editor, false);
    const nextHoveredId2 = getShapeToHover(editor);
    return editor.setHoveredShape(nextHoveredId2);
  }
  if (hoverLockedEditors.get(editor)) {
    return void 0;
  }
  const currentHoveredId = editor.getHoveredShapeId();
  if (!currentHoveredId) {
    hoverLockedEditors.set(editor, true);
    return void 0;
  }
  const nextHoveredId = getShapeToHover(editor);
  if (nextHoveredId === currentHoveredId) {
    return void 0;
  }
  editor.setHoveredShape(null);
  hoverLockedEditors.set(editor, true);
  return void 0;
}
const THROTTLE_MS = process.env.NODE_ENV === "test" ? 0 : 32;
const editorThrottles = /* @__PURE__ */ new WeakMap();
function getThrottled(editor) {
  let throttled = editorThrottles.get(editor);
  if (!throttled) {
    throttled = throttle(_updateHoveredShapeId, THROTTLE_MS);
    editorThrottles.set(editor, throttled);
  }
  return throttled;
}
function updateHoveredShapeId(editor) {
  getThrottled(editor)(editor);
}
function cancelUpdateHoveredShapeId(editor) {
  editorThrottles.get(editor)?.cancel();
}
export {
  cancelUpdateHoveredShapeId,
  updateHoveredShapeId
};
//# sourceMappingURL=updateHoveredShapeId.mjs.map
